"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (serviceId, serviceName, createBy, method) { return function (dispatch, getState) {
        var appState = getState();
        console.log("start call api");
        if (appState && appState.serviceManage && method == "POST") {
            var body = {
                'service_name': serviceName,
                'create_by': createBy
            };
            fetch("/v1/service", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICE', model: data });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICE' });
        }
        if (appState && appState.serviceManage && method == "DELETE") {
            fetch("/v1/service/" + serviceId, {
                method: 'DELETE'
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICE', model: data });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICE' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_SERVICE':
            return {
                isLoading: false
            };
        case 'RECEIVE_SERVICE':
            return {
                isLoading: true,
                response: action.model
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=ServiceManage.js.map